import { render, staticRenderFns } from "./DbDashboard.vue?vue&type=template&id=64946e0d&"
import script from "./DbDashboard.vue?vue&type=script&lang=js&"
export * from "./DbDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports